//////////////////////////////////////////////////////////////////////
//
//  10/02/18
//  src/containers/BLine.js
//
//  This file will format a single line to display on a Black Board.
//
//  This is how you I centered the text in the Black Board.
//  https://blog.mastykarz.nl/measuring-the-length-of-a-string-in-pixels-using-javascript/
//

import React, { Component } from 'react';
import './BLine.css';

class BLine extends Component {

  visualLength( str ) {
    //  Note:  To make this work correctly you MUST choose the 'getElementById'
    //  that matches the id for the font-family that matches what you are trying
    //  to calculate the center of (see BBoard.css).
    var ruler = document.getElementById( "root_ruler_atma" );
    ruler.innerHTML = str;
    return ruler.offsetWidth;
  }

  render() {
    const bwidth  = 300;      // This is the width of the blackboard.
    const bheight = 225;      // This is the height of the blackboard.
    const bheight_top = 25;   // This is the 'padding' at the top of the blackboard.
    const bheight_bot = 25;   // This is the 'padding' at the bottom of the blackboard.

    var { bl_top, bl_txt } = this.props;

    var bl_left = 0;
    var len     = this.visualLength( bl_txt );  // What is the 'pixel' length of the text string
    var tmp = ( bwidth / 2 ) - ( len / 2 );     // Center the text.
    if( tmp > 0 ) { bl_left = tmp; }            // If too big, leave value at init value of 0.
//  console.log( "bwidth: "+bwidth+", len: "+len+", tmp: "+tmp );	

    if( bl_top < bheight_top )              { bl_top = bheight_top; }   // Don't put too close to the top.
    if( bl_top > ( bheight - bheight_bot )) { bl_top = bheight - bheight_bot; } // Don't put too close to the bottom.
 
    return (
      <div className="BLineTop">
        <div className="BLineText" style={{ top : bl_top+"px", left : bl_left+"px" }}>{ bl_txt }</div>
      </div>
    );
  }
}

export default BLine;




// WEBPACK FOOTER //
// ./src/components/BLine.js